const healthContent = {
  title: 'Información sanitaria',
  message: 'Todos nuestros centros son desinfectados entre cada paciente, ademas se toma temperatura antes de entrar.',
  btnMsg: 'CONOCE TODAS LAS MEDIDAS AQUÍ',
  zero: 0,
  healthInfo: 'https://mymoons.[domain]/blog/reapertura-de-centros'
}

export default healthContent
